export const MOCK_VTR_KEY = 'MOCK-VTR-001'

const buildMockCbEntry = (
  location: string,
  overrides: {
    codebeamerTestcaseId?: string
    oddElementTypes?: string[]
    taxonomies?: string[]
    numUniqueElements?: number
    targetNumPerElement?: number
    location?: string
  },
) => ({
  tracker: '',
  parent: '',
  status: 'Open',
  type: 'V&V',
  submittedBy: '',
  modifiedBy: '',
  numUniqueElements: overrides.numUniqueElements ?? 10,
  location: overrides.location ?? location,
  targetNumPerElement: overrides.targetNumPerElement ?? 10,
  targetUnit: '[n]',
  targetConstraints: '',
  fleetTarget: 'mock-fleet',
  codebeamerTestcaseId: overrides.codebeamerTestcaseId ?? '',
  oddElementTypes: overrides.oddElementTypes ?? [],
  taxonomies: overrides.taxonomies ?? [],
})

export const buildMockVtrData = (metroName: string) => ({
  key: MOCK_VTR_KEY,
  type: 'V&V',
  resolution: '',
  priority: 'Medium',
  fixVersion: '',
  securityLevel: '',
  epicLink: '',
  location: metroName,
  testType: '',
  testSpecification: '',
  riskLevel: '',
  targetCompoundRelease: '',
  requestedSoftwareVersion: '',
  mapVersion: '',
  label: '',
  deviationPermission: '',
  description:
    'Mock VTR ticket for testing requirements across all ODD element types',
  status: 'Open',
  codebeamerId: 'MOCK-ODD-Stop',
  feature: '',
  sprint: '',
  links: '',
  cbData: [
    // Standard ODD element types
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-Stop',
      oddElementTypes: ['Stop'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-TrafficLight',
      oddElementTypes: ['Traffic Light'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-Yield',
      oddElementTypes: ['Yield'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-NoEntry',
      oddElementTypes: ['No Entry'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-PedCrossing',
      oddElementTypes: ['Pedestrian Crossing'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-RailroadCrossing',
      oddElementTypes: ['Railroad Crossing'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-NoTurnOnRed',
      oddElementTypes: ['No Turn on Red'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-OneWay',
      oddElementTypes: ['One Way'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-Roundabout',
      oddElementTypes: ['Roundabout'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-BusStop',
      oddElementTypes: ['Bus Stop'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-SchoolZone',
      oddElementTypes: ['School Zone'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-ODD-RightOnRed',
      oddElementTypes: ['Right on Red'],
    }),
    // Edge cases
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-NoLocation',
      oddElementTypes: ['Stop'],
      location: '',
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-TaxonomyMatch-StopSign',
      taxonomies: [
        'scenery_elements/drivable_area/sign_signal_barrier/sign_signal_barrier_type/regulatory_sign/right_of_way_sign/right_of_way_sign_stop/US/R1-1',
      ],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-MultiType-StopYield',
      oddElementTypes: ['Stop', 'Yield'],
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-SingleElement-Stop',
      oddElementTypes: ['Stop'],
      numUniqueElements: 1,
      targetNumPerElement: 1,
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-Total>Unique-Stop',
      oddElementTypes: ['Stop'],
      numUniqueElements: 3,
      targetNumPerElement: 6,
    }),
    buildMockCbEntry(metroName, {
      codebeamerTestcaseId: 'MOCK-EDGE-NoOddElement',
    }),
  ],
})
